import React from 'react';
import { Outlet } from "react-router-dom";

import TopBar from "./TopBar/TopBar";
import "./style.css";

interface ParentComponentProps {
}

const DefaultLayout: React.FC<ParentComponentProps> = () => {
    return (
        <div className="default-layout">
            <div className="top-bar">
                <TopBar />
            </div>
            <Outlet />
            <div className="bottom-bar">
                <a href='https://thebackninegolf.com/terms/' target="_blank" rel="noopener noreferrer">Website Terms & Conditions</a> | <a href='https://thebackninegolf.com/privacy-policy/' target="_blank" rel="noopener noreferrer">Website Privacy Policy</a>
            </div>
        </div>
    );
};

export default DefaultLayout;
